module.exports = __webpack_public_path__ + "img/adminprogramme2.3b0b7a0f.png";